import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

import { Modal } from '../../ui/view/Modal';
import { PressImageDetails } from '../PressImageDetails';
import { DownloadLight } from '../../ui/icon/DownloadLight';

function PressImage({
  res,
  type,
}) {
  const viewModal = useRef(null);

  const handleModalOpen = useCallback(() => {
    viewModal.current.instance.show();
  }, []);

  return (
    <>
      <Modal ref={viewModal} title={res.title}>
        <PressImageDetails pressImage={res} type={type} />
      </Modal>
      <div className={`col-md-6 col-lg-4 ${type === 'public' ? 'col-xl-3' : ''}`}>
        <div className="card">
          <div className="card-body">
            <div className="card-head" onClick={() => handleModalOpen()} onKeyDown={() => handleModalOpen()} role="button" tabIndex="0">
              {res.pressImage && (
                <img
                  src={res.pressImage.transforms.pressImageCard.url}
                  alt={res.alt || res.title}
                />
              )}
            </div>
            <h3>{res.title}</h3>
            {res.pressImageCaption && (
              <div className="mb-2 mb-md-3">
                <span className="figure-caption">
                  {res.pressImageCaption}
                </span>
              </div>
            )}
            <a href={res.pressImage.url} className="press-release-pack__button" target="_blank" rel="noreferrer" download>
              <DownloadLight />
              Download image
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

PressImage.propTypes = {
  res: PropTypes.oneOfType([PropTypes.object]).isRequired,
  type: PropTypes.string,
};

PressImage.defaultProps = {
  type: 'public',
};

export { PressImage };
